"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.StandardBanner = exports.FullWidthContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreSimpleGrid = require("@legacy-vfuk/core-simple-grid");

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FullWidthContainer = _styledComponents["default"].div.withConfig({
  displayName: "StandardBannerstyle__FullWidthContainer",
  componentId: "sc-1lqvpai-0"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;background:", ";position:relative;display:flex;justify-content:center;overflow:hidden;"], props.standardBannerTheme.appearance[props.appearance].backgroundColor);
});

exports.FullWidthContainer = FullWidthContainer;

var StandardBanner = _styledComponents["default"].div.withConfig({
  displayName: "StandardBannerstyle__StandardBanner",
  componentId: "sc-1lqvpai-1"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;max-width:", "px;", "{flex-direction:column-reverse;}", ""], props.theme.gridConfig.springWidth, _coreSimpleGrid.SimpleGridStyles.SimpleGrid, _coreMixins.respondTo.lg((0, _styledComponents.css)(["", "{flex-direction:", ";}"], _coreSimpleGrid.SimpleGridStyles.SimpleGrid, props.contentAlignment === 'right' ? 'row-reverse' : 'row')));
});

exports.StandardBanner = StandardBanner;

var TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "StandardBannerstyle__TextWrapper",
  componentId: "sc-1lqvpai-2"
})(function () {
  return (0, _styledComponents.css)(["", ";"], (0, _coreMixins.advancedSpacing)('padding', [8, 4]));
});

exports.TextWrapper = TextWrapper;
//# sourceMappingURL=StandardBanner.style.js.map